<template>
  <div class="row">
    <div class="col-sm-12 col-md-12 breadcrumb-side-button">
      <div class="float-md-right mb-3">
        <el-tooltip
          placement="top"
          :effect="theemMode.darkMode == true ? 'light' : 'dark'"
          :content="$t('instruction')">
            <button
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="instructionOpen">
            <!-- {{ $t("instruction") }} -->
            <app-icon name="book-open" />
          </button>

        </el-tooltip>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
      <div class="alert alert-info" role="alert">
        <button type="button" class="close" @click.prevent="instructionClose">
          <h5 aria-hidden="true">&times;</h5>
        </button>
        <!-- <hr> -->
        <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_site") }}</h5>
        <p class="mb-0">{{ $t("introduction_job_site") }}</p>
        <strong>Actions:</strong>
        <ul>
          <li><strong>{{ $t("add_site") }} :</strong> {{ $t("add_site_detail") }}</li>
          <li><strong>{{ $t("edit_site") }} :</strong> {{ $t("edit_site_detail") }}</li>
          <li><strong>{{ $t("attach_document") }} :</strong> {{ $t("attach_document_detail") }}</li>
          <li><strong>{{ $t("assign_user") }} :</strong> {{ $t("assign_user_detail") }}</li>
          <li><strong>{{ $t("print") }} :</strong> {{ $t("print_detail") }}</li>
          <li><strong>{{ $t("site_induction_tasks") }} :</strong> {{ $t("site_induction_tasks_detail") }}</li>

        </ul>
      </div>
    </div>
    <div class="col-sm-12 col-md-12">
      <div class="card card-with-search border-0 card-with-shadow">
        <div class="text-justify">
            <app-tab :tabs="tabsHorizontal" type="horizontal" />
        </div>
      </div>
      <job-bid
      v-if="isAddEditModalActive"
      :table-id="tableId"
      @close-modal="closeAddEditModal"
      />
    </div>
  </div>
</template>
<script>
import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Tabs",
  components: { CopyButton },
  data() {
    return {
      instructionShow: false,
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Public Site",
          component: "job-site-public",
          permission: "",
          props: {id:this.$attrs['props'].id}
        },
        {
          icon: "link",
          name: "Private Site",
          component: "job-site-private",
          permission: "",
          props: {id:this.$attrs['props'].id}
        },
      ],
    };
  },
  mounted() {
    this.$attrs['props'].close(false);
  },
  methods: {
    instructionOpen() {
      this.$attrs['props'].close(false);
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  },
};
</script>
